import { useMutation } from '@tanstack/react-query';
import { api } from '../api/axios';


export const useLoginMutation = () => {
  return useMutation({
    mutationFn: async (credentials) => {
      const response = await api.post('/v1/admin/auth/login', credentials);
   
      return response.data;
    }
  });
};